import { useEffect } from "react";
import { apiClient } from ".";
import { useLocation, useParams } from "react-router-dom";
import { REGION_ORIGINS, type RegionIds } from "utils/api-client/regions";

export function APIRegionListener() {
  const { regionId } = useParams<{ regionId: RegionIds | undefined }>();
  const location = useLocation();

  useEffect(() => {
    if (regionId) {
      apiClient.setBaseOrigin(REGION_ORIGINS[regionId]);
    }
  }, [regionId, location.pathname]);

  return null;
}
